import { CaretLeftIcon } from '@phosphor-icons/react';
import { Modal as CustomModal, Flex, Typography } from 'antd';
import React from 'react';

import Button from 'components/atoms/Button';
import Icon, { IconName } from 'components/atoms/Icon';

export interface ModalProps {
  isOpen: boolean;
  className?: string;
  children?: React.ReactNode;
  width?: number;
  closeIcon?: boolean;
  title?: string | React.ReactNode;
  height?: number
  back?: {
    isShow?: boolean;
    onClick?: () => void;
    iconName?: IconName;
  };
  okButton?: {
    text?: string
    isLoading?: boolean
    disabled?: boolean
    handleClick?: () => void;
  },
  cancelButton?: {
    text?: string
    isLoading?: boolean
    disabled?: boolean
    handleClick?: () => void;
  },
  zIndex?: number;
  onCancel?: () => void;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  className,
  children,
  width,
  closeIcon = false,
  title,
  back,
  cancelButton,
  okButton,
  zIndex,
  height,
  onCancel
}) => (
  <div className="o-modal">
    <CustomModal
      open={isOpen}
      className={`o-modal_container ${className}`}
      footer={null}
      closeIcon={closeIcon}
      maskClosable
      centered
      width={width}
      onCancel={onCancel || cancelButton?.handleClick}
      title={(
        <Flex align="center" gap={10}>
          {back?.isShow && (
            <Button variant="icon" onClick={back.onClick} className="modal_closeBtn">
              {back.iconName ? <Icon iconName={back.iconName} size="16" /> : <CaretLeftIcon size={24} className="modal-iconBack" />}
            </Button>
          )}
          {typeof title === 'string' ? (
            <Typography.Title level={4} style={{ marginBottom: 0 }}>
              {title}
            </Typography.Title>
          ) : title}
        </Flex>
      )}
      zIndex={zIndex}
    >
      <div style={{ height }} className="o-modal-content">
        {children}
        <div className="o-modal__buttons">
          {cancelButton && cancelButton.text && (
            <Button onClick={cancelButton.handleClick} isLoading={cancelButton.isLoading} disabled={cancelButton.disabled} variant="outline">
              {cancelButton.text || ''}
            </Button>
          )}
          {okButton && okButton.text && (
            <Button onClick={okButton.handleClick} isLoading={okButton.isLoading} disabled={okButton.disabled} className="o-modal__buttonOk">
              {okButton.text || ''}
            </Button>
          )}
        </div>
      </div>
    </CustomModal>
  </div>
);

export default Modal;
